import { CompareDurationDefinitionInfo } from '@modules/analysis/components/AnalysisDefinitionInfo';
import {
  DEFAULT_COMPARE_DURATION_A_NAME,
  DEFAULT_COMPARE_DURATION_B_NAME,
} from '@modules/quantify/constants';
import { useGetFormattedDurationFieldLabels } from '@modules/quantify/hooks';
import { useGetCompareColors } from '@modules/quantify/hooks/useGetCompareColors';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { CircleRounded } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { AnalysisDefinitionInfoItem } from './AnalysisDefinitionInfoItem';

export const QuantifyDurationDefinitionInfo = () => {
  const { colorA, colorB } = useGetCompareColors();
  const { durationLabel, compareDurationLabel } =
    useGetFormattedDurationFieldLabels();
  const compareDurationAName = useQuantifyStore(
    ({ metadata }) =>
      metadata.compareDurationField.compareDurationAName ||
      DEFAULT_COMPARE_DURATION_A_NAME,
  );
  const compareDurationBName = useQuantifyStore(
    ({ metadata }) =>
      metadata.compareDurationField.compareDurationBName ||
      DEFAULT_COMPARE_DURATION_B_NAME,
  );

  if (compareDurationLabel.primary) {
    return (
      <>
        <AnalysisDefinitionInfoItem
          leftNode={
            <Stack direction="row" alignItems="center" spacing={0.6}>
              <CircleRounded sx={{ color: colorA, width: 8 }} />
              <Typography variant="caption">{compareDurationAName}:</Typography>
            </Stack>
          }
          rightNode={<CompareDurationDefinitionInfo compareField="A" />}
        />
        <AnalysisDefinitionInfoItem
          leftNode={
            <Stack direction="row" alignItems="center" spacing={0.5}>
              <CircleRounded sx={{ color: colorB, width: 8 }} />
              <Typography variant="caption">{compareDurationBName}:</Typography>
            </Stack>
          }
          rightNode={<CompareDurationDefinitionInfo compareField="B" />}
        />
      </>
    );
  }

  return (
    <AnalysisDefinitionInfoItem
      leftNode="Duration:"
      rightNode={
        <Stack>
          <Typography variant="caption">{durationLabel.primary}</Typography>
          {durationLabel.secondary && (
            <Typography variant="caption">{durationLabel.secondary}</Typography>
          )}
        </Stack>
      }
    />
  );
};
